var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flexwrap"},[_c('FleetStatus',{attrs:{"title":"Bundles","values":_vm.bundleCounts,"value-key":"count"}}),_vm._v(" "),_c('FleetStatus',{attrs:{"title":"Resources","values":_vm.resourceCounts,"value-key":"count"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }